/**
 * @typedef {import("@prismicio/client").Content.ImageBlockSlice} ImageBlockSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ImageBlockSlice>} ImageBlockProps
 * @param {ImageBlockProps}
 */
import { PrismicNextImage } from "@prismicio/next";
import styled from "styled-components";

const ImageContainer = styled.div`
  max-width: 100%;
`;

const ImageBlock = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <ImageContainer>
        <PrismicNextImage 
         style={{
          maxWidth: "100%",
          height: "auto",
         }}
        field={slice.primary.image} />
      </ImageContainer>
    </section>
  );
};

export default ImageBlock;
